export const selectExtension = state => state.extension;

const _filterMain = item => !item.main;

export const getFilteredMediaToSelectFrom = state =>
  state.extension.media.filter(_filterMain);



// WEBPACK FOOTER //
// ./src/selectors/extension.selectors.js